export default {
	GET_MONEY_METRICS: ({ listId, year, month }) => {
		const queryParams = new URLSearchParams();
		queryParams.append("listId", listId);
		queryParams.append("year", year);
		queryParams.append("month", month);
		return `/economos/metrics/money?${queryParams.toString()}`;
	},
};
